import { CategorizedThumbnails } from "./CategorizedThumbnails";
import { classes } from "portal/theme/theme";
import { Dimensions } from "portal/utils/categoryCollection/image";
import { IconButton, Paper, Tooltip } from "@mui/material";
import { OrderedCategorizedImage } from "./useCategorizedImageData";
import { PredictionPoint } from "protos/veselka/prediction_point";
import { StringDiff } from "portal/utils/strings";
import { useTranslation } from "react-i18next";
import { useUserPreferences } from "portal/state/store";
import MoreIcon from "@mui/icons-material/Add";
import React, { FC } from "react";

interface CategorizedImagesGridProps {
  dimensions: Dimensions;
  diff?: StringDiff;
  hasMore: boolean;
  images: OrderedCategorizedImage[];
  loadMore: () => void;
  loadMoreRef: (node: HTMLDivElement | null) => void;
  onDoubleClick: (index: number, data: PredictionPoint) => void;
  onRemove?: (predictionPointId: string) => void;
  onRightClick?: (
    predictionPointId: string,
    position: { x: number; y: number }
  ) => void;
  paperClassName?: string;
}

export const CategorizedImagesGrid: FC<CategorizedImagesGridProps> = ({
  dimensions,
  diff,
  hasMore,
  images,
  loadMore,
  loadMoreRef,
  onDoubleClick,
  onRemove,
  onRightClick,
  paperClassName,
}) => {
  const { t } = useTranslation();
  const userPreferences = useUserPreferences();

  return (
    <div className="flex flex-col">
      <Paper
        elevation={0}
        className={classes("flex gap-1 p-1 flex-wrap", paperClassName)}
        style={{ minHeight: `${dimensions.height + 8}px` }}
      >
        <CategorizedThumbnails
          dimensions={dimensions}
          images={images}
          showLabels={userPreferences.categoryCollection.showLabels}
          onRemove={
            onRemove
              ? (predictionPointId) => {
                  onRemove(predictionPointId);
                }
              : undefined
          }
          onDoubleClick={onDoubleClick}
          onRightClick={onRightClick}
          diff={diff}
        />
        {hasMore && (
          <div className="flex items-center" ref={loadMoreRef}>
            <Tooltip title={t("utils.lists.loadMore")}>
              <span>
                <IconButton
                  className="text-carbon-orange"
                  size="small"
                  onClick={loadMore}
                  aria-label={t("utils.lists.loadMore")}
                >
                  <MoreIcon className="text-inherit" />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        )}
      </Paper>
    </div>
  );
};
